import styled from "@emotion/styled";
import { MDSText } from "@/mds";

const NARROW_BREAKPOINT = 400;

/**
 * Outer wrapper that establishes the container query context.
 */
export const StyledCalendarItemContainer = styled.div`
  container-type: inline-size;
  container-name: calendar-item;
`;

/**
 * Wide layout - horizontal with checkbox, status, and actions in a row.
 * Hidden when container is narrow.
 */
export const StyledWideLayout = styled.div<{ $isLoading?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  opacity: ${({ $isLoading }) => ($isLoading ? 0.4 : 1)};

  @container calendar-item (max-width: ${NARROW_BREAKPOINT}px) {
    display: none;
  }
`;

/**
 * Narrow layout - checkbox with label+subtitle and actions.
 * Hidden when container is wide.
 */
export const StyledNarrowLayout = styled.div<{ $isLoading?: boolean }>`
  display: none;
  opacity: ${({ $isLoading }) => ($isLoading ? 0.4 : 1)};

  @container calendar-item (max-width: ${NARROW_BREAKPOINT}px) {
    display: flex;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[2]};
  }
`;

export const StyledCheckboxWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;

export const StyledLabelText = styled(MDSText)`
  cursor: pointer;
`;

/**
 * Wrapper for label + subtitle content inside checkbox.
 */
export const StyledLabelWithSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  cursor: pointer;
`;

export const StyledStatusContent = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
`;

/**
 * Subtitle status - smaller text, displayed under the label.
 */
export const StyledSubtitleStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const StyledActionsWrapper = styled.div`
  flex-shrink: 0;
  align-self: flex-start;
`;
